// Vue
import { Vue, Component, Prop, Inject } from "vue-property-decorator";

// Template
import template from "./template.vue";

import ModuleWrapper from "#/components/module_wrapper/ModuleWrapper";

import ModuleBase from "#/common/ModuleBase";

import { PiOverviewModuleItem } from "./item/PiOverviewModuleItem";

@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
    PiOverviewModuleItem,
  },
})
export class PiOverviewModule extends ModuleBase {
  getBackgroundColorFromInstance(instance: object) {
    return "black";
  }
}
